/* tslint:disable variable-name */

import { OUTER_LIBRARY_ID } from 'constants/misc';
import EventsManager from 'managers/events.manager';

import NativeScroll from './native';
import IScrollScroll from './iscroll';
import { isMobile } from 'utils';

export interface ScrollHandler {
  type: string,
  init(element: HTMLElement): Promise<void>,
  reinitialize(): Promise<void>,
  enable(): void,
  disable(): void,
  onScroll(callback: (data: { y: number }) => void): void,
  offScroll(): void,
  scrollTo(offset: number, duration?: number): void,
  refresh(height?: number): void,
  onResize(): void,
  y: number,
}

class ScrollManager {
  public initiated = false;
  private position = 0;
  private _handler!: ScrollHandler;

  constructor() {
    EventsManager.once('LIBRARY_RENDERED', this.init);
  }

  public init = async () => {
    if (this.hasNativeSupport()) {
      this._handler = new NativeScroll();
    } else {
      this._handler = new IScrollScroll();
    }

    await this.handler.init(this.scrollerElement);
    this.notify();
    this.setScrollClass();

    EventsManager.on('RESIZE', () => this.handler.onResize());
  }
  public onInit() {
    if (this.initiated) return Promise.resolve();

    return new Promise((resolve) => EventsManager.once('SCROLL_INITIATED', resolve));
  }

  private hasNativeSupport() {
    const hasIOSScrolling = 'WebkitOverflowScrolling' in document.documentElement.style;
    const hasNativeScrolling = isMobile || hasIOSScrolling;
    return hasNativeScrolling;
  }
  private notify() {
    this.initiated = true;
    EventsManager.emit('SCROLL_INITIATED');
  }
  private setScrollClass() {
    const className = this.isNative ? 'native' : 'iscroll';
    this.scrollerElement.classList.add(className);
  }

  public scrollTop(duration = 150) {
    this.handler.scrollTo(0, duration);
  }

  public savePosition() {
    this.position = this.handler.y;
  }
  public applyPosition() {
    this.handler.scrollTo(this.position, 0);
    this.handler.onResize();
  }

  get scrollerElement() {
    return document.querySelector(`#${ OUTER_LIBRARY_ID }`) as HTMLElement;
  }
  get handler() {
    return this._handler;
  }
  get isNative() {
    return this.handler.type === 'native';
  }
  get isIScroll() {
    return this.handler.type === 'iscroll';
  }
}

const service = new ScrollManager();
if (__DEV__) {
  window.__SCROLL = service;
}

export default service;
